<div class="informate_select_wrapper" [formGroup]="form">
    <mat-label class="mat-label-general" [ngbTooltip]="washers_tooltip" placement="right" container="body" tooltipClass="custom-tooltip">
        <!-- Washers -->
        {{ 'CUSTOM_FLANGE_PAGE.LABELS.CALC_INPUT.WASHERS' | transloco }}
    </mat-label>
    <!--tool-tip template start-->
    <ng-template #washers_tooltip>
        <p>
            {{ 'TOOLTIP.INFORMATE_CALC_LABELS.WASHERS' | transloco }}
        </p>
    </ng-template>
    <!--tool-tip template end-->
    <br />
    <mat-select class="mat-select-general input-form-class" formControlName="washer" name="washer" [class.spinner]="loading">
        <mat-option class="option-list" [value]="0">None</mat-option>
        <mat-option class="option-list" *ngFor="let wl of washerList" [value]="wl.washerDimensionId">{{ wl.qualifiedName }}</mat-option>
    </mat-select>
</div>
